export enum JobTypes {
  FileCopyInternal = "FileCopyInternal",
  FileMoveInternal = "FileMoveInternal",
  FileDeleteInternal = "FileDeleteInternal",
  FileParse = "FileParse",
  FilePackageParse = "FilePackageParse",
  FileWriteInternal = "FileWriteInternal",
  FileXmlTransform = "FileXmlTransform",
  FileMovieLabsMetadataExport = "FileMovieLabsMetadataExport",
  FileCopyInternalAsync = "FileCopyInternalAsync",
  FileFtpTransferInternalAsync = "FileFtpTransferInternalAsync",
  ConvertSubtitle = "ConvertSubtitle",
  FileCopyAmberfin = "FileCopyAmberfin",
  FileMoveAmberfin = "FileMoveAmberfin",
  FileDeleteAmberfin = "FileDeleteAmberfin",
  FileAsperaTransferServerToServerAmberfin = "FileAsperaTransferServerToServerAmberfin",
  FileAsperaTransferFaspUsingAscpAmberfin = "FileAsperaTransferFaspUsingAscpAmberfin",
  FileAsperaTransferDropboxAmberfin = "FileAsperaTransferDropboxAmberfin",
  FileAsperaTransferUploadShares = "FileAsperaTransferUploadShares",
  FileAsperaTransferTracking = "FileAsperaTransferTracking",
  FileAsperaTransferUploadFaspex = "FileAsperaTransferUploadFaspex",
  FileAsperaTransferUploadNodeApi = "FileAsperaTransferUploadNodeApi",
  FileAsperaTransferServerToServer = "FileAsperaTransferServerToServer",
  FileFtpTransferAmberfin = "FileFtpTransferAmberfin",
  FileAmazonS3TransferUploadAmberfin = "FileAmazonS3TransferUploadAmberfin",
  FileAmazonS3TransferDownloadAmberfin = "FileAmazonS3TransferDownloadAmberfin",
  FileHash = "FileHash",
  ExecuteCommandAmberfin = "ExecuteCommandAmberfin",
  TranscodeByTemplateAmberfin = "TranscodeByTemplateAmberfin",
  TranscodeByXmlAmberfin = "TranscodeByXmlAmberfin",
  FileCopyMultiAmberfin = "FileCopyMultiAmberfin",
  TranscodeUsingFFmpeg = "TranscodeUsingFFmpeg",
  AudioLanguageDetection = "AudioLanguageDetection",
  AudioAtmosRenderer = "AudioAtmosRenderer",
  TranscodeVantage = "TranscodeVantage",
  ArchiveDiva = "ArchiveDiva",
  RestoreDiva = "RestoreDiva",
  DeleteDiva = "DeleteDiva",
  ArchiveSnsm = "ArchiveSnsm",
  RestoreSnsm = "RestoreSnsm",
  DeleteSnsm = "DeleteSnsm",
  TruncateSnsm = "TruncateSnsm",
  ErpWorkOrderPush = "ErpWorkOrderPush",
  CreateThumbnailFromDoc = "CreateThumbnailFromDoc",
  AudioWaveformGenerate = "AudioWaveformGenerate",
  AudioMeasure = "AudioMeasure",
  AuthotSpeechToText = "AuthotSpeechToText",
  WhisperSpeechToText = "WhisperSpeechToText",
  FileM7MetadataExport = "FileM7MetadataExport",
  QcVerifyFileBaton = "QcVerifyFileBaton",
  DcpKdmGeneration = "DcpKdmGeneration",
  RestoreAmazonS3 = "RestoreAmazonS3",
  CopyAmazonS3ObjectToS3 = "CopyAmazonS3ObjectToS3",
  UploadAmazonS3 = "UploadAmazonS3",
  DownloadAmazonS3 = "DownloadAmazonS3",
  GlobecastUploadDcp = "GlobecastUploadDcp",
  GlobecastTransferDcp = "GlobecastTransferDcp",
  VideoImageExtract = "VideoImageExtract",
  ConvertImage = "ConvertImage",
  FileLiquidMetadataExport = "FileLiquidMetadataExport",
  FileCompress = "FileCompress",
  FileUncompress = "FileUncompress",
  GenerateAAF = "GenerateAAF",
  FingerprintGoogle = "FingerprintGoogle",
  FileMoveMultiInternal = 'FileMoveMultiInternal',
  ExecuteCommandInternal = 'ExecuteCommandInternal',
  TranscodeHybrik = 'TranscodeHybrik',
  TranscodeHybrikProxyAuto = 'TranscodeHybrikProxyAuto',
  TranscodeDcp = 'TranscodeDcp',
  AudioNormalizer = 'AudioNormalizer',
  AudioSilenceDetection = 'AudioSilenceDetection',
  AudioSyncComparer = 'AudioSyncComparer',
  AudioLayoutDetection = 'AudioLayoutDetection',
  AudioAtmosConverter = 'AudioAtmosConverter',
  FileHDRMetadataExport = 'FileHDRMetadataExport',
  QcVerifyFileHybrik = 'QcVerifyFileHybrik',
  IngestMezzanifierChecker = 'IngestMezzanifierChecker',
  VideoBlackDetection = 'VideoBlackDetection',
  Undefined = "Undefined",
}
